// extracted by mini-css-extract-plugin
export default {"content":"Home_content__vcuYT","buttonSpace":"Home_buttonSpace__th9L9"};